import * as React from 'react'
import { IQuiz } from '../../interfaces/IQuiz'
import { getAssessmentsAvailableOnHomepage } from '../../services/api-requests/api-request'
import { ISchool } from '../../interfaces/school.interface'
import {
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material'
import Image from 'next/image'
import { ICourse } from '../../interfaces/ICourse'
import SchoolHomepageQuizListDialogButtonComponent from './SchoolHomepageQuizListDialogButtonComponent'
import { AuthDialogComponent } from '../Auhentication/LoginComponent/AuthDialogComponent'
import SearchIcon from '@mui/icons-material/Search'
import CancelIcon from '@mui/icons-material/Cancel'
import ShareQuizButton from './ShareQuizButton'
import { useTheme } from '@mui/material/styles'
import { getNextCardImageSrc } from '../ExtraStyleLogic/cardImages'

export default function SchoolHomepageQuizListComponent(props: {
  schoolDetails: ISchool
  courses: ICourse[]
}) {
  const [quizzes, setQuizzes] = React.useState<IQuiz[]>([])
  const [loading, setLoading] = React.useState(false)
  const [openAuthDialog, setOpenAuthDialog] = React.useState<boolean>(false)
  const [searchQuery, setSearchQuery] = React.useState('')
  const [filteredQuiz, setFilteredQuiz] = React.useState<IQuiz[]>([])
  const theme = useTheme()
  const [backgroundImage, setBackgroundImage] = React.useState<string>('')

  const handleOpenAuthDialog = () => {
    setOpenAuthDialog(!openAuthDialog)
  }

  React.useEffect(() => {
    fetchQuizzes()
    setBackgroundImage(getNextCardImageSrc())
  }, [])

  const filterQuiz = (searchQuery: string = '') => {
    if (!searchQuery) {
      setFilteredQuiz(quizzes)
      return
    }
    const _filtered = quizzes.filter(c => {
      return c.name?.toLowerCase()?.includes?.(searchQuery?.toLowerCase())
    })
    setFilteredQuiz(_filtered)
  }

  const fetchQuizzes = async () => {
    try {
      setLoading(true)
      const axiosRes = await getAssessmentsAvailableOnHomepage(
        props.schoolDetails?._id,
      )
      console.log('Quiz list', { axiosRes })
      if (axiosRes?.data?.data) {
        setQuizzes(axiosRes?.data?.data)
        setFilteredQuiz(axiosRes?.data?.data)
      }
      setLoading(false)
    } catch (err) {
      console.log('error fetching quizzes')
      setLoading(false)
    }
  }

  return (
    <div>
      <div>
        <Typography
          align={'center'}
          style={{ color: '#fafafa', marginTop: '20px' }}
          variant={'h6'}
        >
          <b> Explore Quizzes</b>
        </Typography>
      </div>

      <div>
        <div style={{ padding: '20px', maxWidth: '500px', margin: 'auto' }}>
          <TextField
            size="small"
            value={searchQuery}
            placeholder={'Search for quiz'}
            style={{ borderColor: '#fafafa' }}
            InputProps={{
              style: {
                borderRadius: '15px',
                color: '#fafafa',
              },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: '#fafafa' }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      filterQuiz('')
                      setSearchQuery('')
                    }}
                    size={'small'}
                  >
                    <CancelIcon style={{ color: '#fafafa' }} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            variant="outlined"
            label="Search"
            fullWidth={true}
            onChange={e => {
              filterQuiz(e.target.value)
              setSearchQuery(e.target.value)
            }}
          />
        </div>
      </div>

      {loading && (
        <Typography align={'center'} style={{ margin: '50px auto' }}>
          <CircularProgress size={20} />
        </Typography>
      )}

      <div>
        {quizzes?.length === 0 && !loading && (
          <div style={{ padding: '20px' }}>
            <Typography align={'center'}>
              No open public quiz in school
            </Typography>
          </div>
        )}
      </div>

      <div>
        {quizzes?.length !== 0 && filteredQuiz?.length === 0 && !loading && (
          <div style={{ padding: '20px' }}>
            <Typography style={{ color: '#fafafa' }} align={'center'}>
              We couldn't find any quiz that match your search
            </Typography>
          </div>
        )}
      </div>

      <div
        style={{
          minHeight: '350px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          flexWrap: 'wrap',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {filteredQuiz.map(q => {
          return (
            <React.Fragment>
              {' '}
              <Card
                variant="outlined"
                key={q._id}
                style={{
                  width: '100%',
                  margin: '10px',
                  maxWidth: '300px',
                  minWidth: '300px',
                  backgroundColor: '#212330',
                  color: '#fafafa',
                }}
              >
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  {q?.course?.background_image ? (
                    <Image
                      objectFit={'cover'}
                      src={q?.course?.background_image}
                      height={'150'}
                      width={'300'}
                      unoptimized={true} // to reduce load on server for now
                      alt="Quiz image"
                      style={{ objectFit: 'cover', height: '150px' }}
                    />
                  ) : (
                    <Image
                      objectFit={'cover'}
                      src={backgroundImage}
                      height={'150'}
                      width={'300'}
                      unoptimized={true} // to reduce load on server for now
                      alt="Placeholder image"
                      style={{ objectFit: 'cover', height: '150px' }}
                    />
                  )}

                  <ShareQuizButton
                    buttonStyle={{
                      position: 'absolute',
                      bottom: '10px',
                      right: '10px',
                      color: `${theme.palette.primary.main}`,
                      backgroundColor: '#fff',
                      border: `${theme.palette.grey[500]} .5px solid`,
                    }}
                    buttonSize={'small'}
                    school={props.schoolDetails}
                    quiz={q}
                  />
                </div>
                <CardContent
                  component="div"
                  style={{ height: '150px', overflow: 'auto' }}
                >
                  <Typography
                    gutterBottom={true}
                    style={{
                      fontSize: '1.2rem',
                    }}
                    variant="h6"
                  >
                    {q.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      // whiteSpace: "nowrap",
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      height: '40px',
                    }}
                  >
                    {q?.note_before}
                  </Typography>
                  <Typography color={'GrayText'} variant="body2">
                    Deadline: {q.deadline}
                    <br />
                    Time limit: {q.time_limit?.toString() || ''} <br />
                    Number of tries: {q.no_of_tries}
                  </Typography>
                </CardContent>

                <Divider />
                <CardActions
                  style={{
                    display: 'flex',
                    padding: '16px',
                  }}
                >
                  {q?.course_content?._id && (
                    <SchoolHomepageQuizListDialogButtonComponent
                      quiz={q}
                      topic={q.course_content}
                      handleOpenAuthDialog={handleOpenAuthDialog}
                      openAuthDialog={openAuthDialog}
                    />
                  )}
                </CardActions>
              </Card>
            </React.Fragment>
          )
        })}
      </div>
      <AuthDialogComponent
        school_details={props.schoolDetails}
        openAuthDialog={openAuthDialog}
        closeAuthDialogFunction={handleOpenAuthDialog}
      />
    </div>
  )
}
